// A light tap you can feel. Safari has no vibration API, but from iOS 18 toggling a native
// switch (<input type="checkbox" switch>) plays the system tick, and a label click toggles it
// from code, inside the tap that started it. Android uses navigator.vibrate. Elsewhere, nothing.
// Off when Kyle turns haptics off in You, or the phone asks for reduced motion.
let el: HTMLLabelElement | null = null;
const KEY = "musette.haptics";

export const hapticsOn = () => { try { return localStorage.getItem(KEY) !== "off"; } catch { return true; } };
export const setHaptics = (on: boolean) => { try { localStorage.setItem(KEY, on ? "on" : "off"); } catch { /* fine */ } };

export function haptic(kind: "tick" | "thud" = "tick") {
  if (typeof document === "undefined" || !hapticsOn()) return;
  try {
    if (typeof navigator.vibrate === "function") { navigator.vibrate(kind === "thud" ? [12, 40, 12] : 8); return; }
    if (!el) {
      el = document.createElement("label");
      el.setAttribute("aria-hidden", "true");
      el.style.cssText = "position:fixed;left:-9999px;top:0;width:1px;height:1px;overflow:hidden;opacity:0;pointer-events:none";
      const i = document.createElement("input");
      i.type = "checkbox"; i.setAttribute("switch", ""); i.tabIndex = -1;
      el.appendChild(i);
      document.body.appendChild(el);
    }
    el.click();
    if (kind === "thud") setTimeout(() => el?.click(), 70);
  } catch { /* no haptics here */ }
}
